module.exports = __webpack_public_path__ + "assets/1e6470fcd40337be2b1a7feb1e0f600a.mp3";